
const Header=()=>{
    return(
        <div className="d-flex justify-content-start align-items-center">
               <p className="header-txt">لیست مشترکین</p> 
        </div>
    
    )
}
export default Header